<template>
  <div class="showMore text-center py-1" @click="showMore">
    {{ all ? 'Show all orders' : 'Show less' }}
    <font-awesome-icon
      :icon="all ? faChevronDown : faChevronUp"
      class="ml-2 font-weight-light chevron"
    />
  </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';

const props = defineProps({
  all: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['showMore']);

function showMore() {
  emit('showMore');
}
</script>

<style scoped lang="scss">
@use '@/scss/main.scss';

.showMore {
  cursor: pointer;
  width: 100%;
  font-size: x-small;
  border-top: 1px solid main.$grey-1500;
}
</style>
